const dev = {
  URL_BACKEND: process.env.REACT_APP_BACKEND_URL || "http://localhost:3000",
};

const prod = {
  URL_BACKEND: process.env.REACT_APP_BACKEND_URL || "https://memodeep.com:3000"
};

const configApp =
  process.env.REACT_APP_STAGE === undefined ||
  process.env.REACT_APP_STAGE.trim() === "production"
    ? prod
    : dev;

configApp.MAXLECON = 5;
configApp.MAXWORD = 5;
configApp.SUBCRIPTIONFREE = "free";
configApp.SUBCRIPTIONFULL = "full";

configApp.PAYPALPLAN = "P-478032738K6401116MGEM2UI";

export default {
  ...configApp,
};
